import { Injectable } from "@angular/core";
import { Observable, catchError, map, of, tap } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class BuildVersionService {
  public buildVersionAtStartup: string;

  constructor(private http: HttpClient) {}

  public initVersion(): Observable<string> {
    return this.fetchVersion().pipe(tap((v) => (this.buildVersionAtStartup = v)));
  }

  public fetchVersion(): Observable<string> {
    return this.http
      .get("assets/version.txt", {
        headers: new HttpHeaders({ "Cache-Control": "no-cache" }),
        responseType: "text",
      })
      .pipe(map((data) => data as unknown as string));
  }
}
